<script setup lang="ts">
import DataExportDownloadMenu from "@/components/DataExportDownloadMenu.vue";
import BaseReport from "@/pages/Insights/ReportsDetailPage/components/BaseReport.vue";

defineProps({
  dataEndpoint: {
    type: String,
    required: true
  },
  metricEndpoint: {
    type: String,
    required: true
  }
});
</script>

<template>
  <BaseReport
    :metric-endpoint="metricEndpoint"
    :data-endpoint="dataEndpoint"
  >

    <template #metric-content="{metricData}">
      <slot name="metric-content" :metric-data="{metricData}" />
    </template>

    <template #report-content="{ tableData, exportReport }">
      <v-card variant="outlined" class="bg-white mt-4">
        <v-row align="center" class="my-1 px-3">
          <v-spacer/>
          <v-col cols="auto">
            <data-export-download-menu
              :formats="['csv', 'excel']"
              @click="exportReport"
              class="mr-2"
            />
          </v-col>
        </v-row>
        <v-divider/>
      </v-card>

      <slot name="report-table" :table-data="tableData"/>
    </template>
  </BaseReport>
</template>
